export default __webpack_public_path__ + "media/images/footer-logo-162924b4cd7b78e21909f7d6d84cdb8c.png";